import {
	API_POST_REUSABLE_TUBE,
	API_POST_REUSABLE_TUBE_FAIL,
	API_POST_REUSABLE_TUBE_SUCCESS,
	API_GET_MISSING_VOLUME_TUBE,
	API_GET_MISSING_VOLUME_TUBE_FAIL,
	API_GET_MISSING_VOLUME_TUBE_SUCCESS,
} from '../actions/tube';
import { createReducer } from '@reduxjs/toolkit';
import { errorHandler, ErrorAction } from 'utils/error';

const initialState = {
	reusable: { loading: false, list: [] },
	missingVolume: { loading: false, list: [] },
};

const tubes = createReducer(initialState, {
	/** REUSABLE TUBES **/
	[API_POST_REUSABLE_TUBE]: (state) => {
		state.reusable.loading = true;
		state.reusable.list = [];
	},
	[API_POST_REUSABLE_TUBE_FAIL]: (state, action) => {
		state.reusable.loading = false;
		errorHandler('Tube réutilisable', ErrorAction.READ, action.error);
	},
	[API_POST_REUSABLE_TUBE_SUCCESS]: (state, action) => {
		state.reusable.loading = false;
		state.reusable.list = action.payload.data;
	},

	/** REUSABLE MISSING **/
	[API_GET_MISSING_VOLUME_TUBE]: (state, action) => {
		state.missingVolume.loading = true;
		state.missingVolume.list = [];
	},
	[API_GET_MISSING_VOLUME_TUBE_FAIL]: (state, action) => {
		state.missingVolume.loading = false;
		errorHandler('Volume manquant tube', ErrorAction.READ, action.error);
	},
	[API_GET_MISSING_VOLUME_TUBE_SUCCESS]: (state, action) => {
		state.missingVolume.loading = false;
		state.missingVolume.list = action.payload.data;
	},
});

export default tubes;
